<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=600 content-class="round-2xl")
  v-card
    div.py-6.px-10
      .text-xl.mb-4 {{ $t('unassign_review') }}
      .text-md {{ $t('unassign_item_description', { item:itemText }) }}
    v-divider
    v-card-actions.px-6
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="confirm" :loading="isLoading" color="danger500" dark depressed) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ReviewUnassignCustomerDialog',
  props: {
    open: {
      type: Boolean,
    },
    parentReview: {
      type: Object,
      default: () => {
        return {}
      }
    },
    os: {
      type: String,
      default: 'review',
      validator(value) {
        return ['clinic', 'donation', 'connect', 'review'].includes(value)
      }
    },
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    itemText() {
      switch (this.os) {
        case 'clinic':
          return this.$t('patient').toLowerCase()

        case 'review':
          return this.$t('customer').toLowerCase()
      
        default:
          return ''
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog() {
      this.$emit('close')
      this.showDialog = false
    },
    async confirm() {
      this.isLoading = true
      try {
        const { data } = await this.$axios.patch(`/reviews/${this.company.slug}/google_reviews/${this.parentReview.id}`, { customer: null })
        this.$emit('update', data)
        this.showMessage(['success', this.$t('success_message.successfully_updated')])
        this.closeDialog()
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.isLoading = false
      }
    }
  },
}
</script>